import axios from "axios";
import { baseUrl } from "../util";

export const getProductDropdownLCA = ({ setDropdownData }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/bonsai-activity-names-with-units",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      region: "DK",
    },
  };

  axios(config)
    .then(function (response) {
      const uniqueDescriptions = new Set(); // To track unique descriptions

      // Handle the new API response structure with data array
      const dataToFilter = response.data?.data || [];

      const filteredResults = dataToFilter.filter((item) => {
        // Check if the description is already in the Set
        if (!uniqueDescriptions.has(item.name)) {
          uniqueDescriptions.add(item.name); // Add to the Set if it's not already present
          const originalName = item.name; // Store original name for clean value
          // Add unit to display name if unit exists
          if (item.unit) {
            item.name = `${originalName} (${item.unit})`; // Display name with unit
            item.value = `${originalName} (${item.unit})`;
          }
          return true; // Keep this item in the filtered results
        }
        return false; // Filter out duplicates
      });

      setDropdownData(filteredResults);
    })
    .catch(function (error) {
      console.log("Error fetching Bonsai data:", error);
      setDropdownData([]); // Set empty array in case of error
    });
};
